import styled from 'styled-components';

import { theme } from '../../../../global-styles/colors';

export const CoverageItemStyles = styled.article`
  padding: 16px;
  border-radius: 16px;
  background: ${theme.neutrals.white};
  box-shadow: 0 2px 12px rgba(29, 30, 32, 0.12);

  .coverage-item__header {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .coverage-item__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    svg {
      font-size: 16px;
    }
  }
  .coverage-item__main {
    flex: 1;
    min-width: 0;
    p {
      overflow-wrap: anywhere;
    }
  }
`;
